export default {
  hero: {
    "title-line-1": "Access cheaper local solar energy",
    "title-line-2": "no panels required",
    description:
      "Join a solar community near you and reduce your electricity bill while supporting local renewable energy.",
    "cta-find-community": "Find a community near me",
    "cta-check-eligibility": "Check my eligibility",
    "savings-title": "Your estimated savings",
    "community-rate": "Community rate",
    "annual-savings": "Annual Savings",
    "annual-consumption": "Annual consumption (kWh)",
    "current-rate": "Current electricity rate (€/kWh)",
    "slider-hint":
      "These are estimated savings based on typical community solar rates. Actual savings may vary.",
  },
  "why-join": {
    title: "Why join community solar?",
    subtitle:
      "Access renewable energy without the hassle or expense of installing your own panels",
    cards: {
      "no-investment": {
        title: "No investment required",
        description: "No panels, no installation, no upfront cost.",
      },
      "fixed-pricing": {
        title: "Fixed, predictable pricing",
        description: "Stable rates protected from market volatility.",
      },
      "support-local": {
        title: "Support local energy",
        description: "Power your home with electricity from nearby producers.",
      },
    },
  },
  "how-it-works": {
    title: "How It Works",
    subtitle: "Getting started is simple and effortless.",
    steps: {
      "step-1": {
        number: "01",
        title: "Find a community near you",
        description: "Browse solar communities available in your region.",
      },
      "step-2": {
        number: "02",
        title: "Sign up with your address + PDL",
        description: "Fill in a simple registration form.",
      },
      "step-3": {
        number: "03",
        title: "Give consent for meter data access",
        description: "Secure access via the Enedis API.",
      },
      "step-4": {
        number: "04",
        title: "Start receiving local solar energy",
        description: "Start saving on your electricity bill.",
      },
    },
  },
  "can-you-join": {
    title: "Can you join?",
    subtitle: "Most households are already eligible",
    subtext: "95% of French households are already eligible",
    criteria: {
      linky: "Linky smart meter installed",
      distance: "Located within 2–20km of a solar community",
      supplier: "Keep your current electricity supplier",
    },
    cta: "Check my eligibility",
    "image-alt": "House with solar panels - illustration placeholder",
  },
  "explore-communities": {
    title: "Explore Communities Near You",
    subtitle: "Find the perfect solar community in your area",
    "filters-title": "Filters",
    filters: {
      "sort-by": {
        label: "Sort by",
        options: {
          nearest: "Nearest first",
          "price-asc": "Price (low to high)",
          "price-desc": "Price (high to low)",
          capacity: "Capacity",
        },
      },
      "max-price": {
        label: "Max price",
        options: {
          "0.165": "up to 0.165 kWh",
          "0.170": "up to 0.170 kWh",
          "0.175": "up to 0.175 kWh",
          "0.180": "up to 0.180 kWh",
        },
      },
      "max-distance": {
        label: "Max distance",
        options: {
          "5": "Within 5 km",
          "10": "Within 10 km",
          "15": "Within 15 km",
          "20": "Within 20 km",
        },
      },
    },
    available: "Available",
    full: "Full",
    "join-community": "Join community",
    "join-waitlist": "Join waitlist",
    "map-placeholder": "Map placeholder",
  },
  "join-in-three-steps": {
    title: "Join in 3 simple steps",
    subtitle: "Quick, easy, and completely online",
    steps: {
      "step-1": {
        title: "Enter email + address",
        description: "Basic contact information to get started",
      },
      "step-2": {
        title: "Provide PDL + consent",
        description: "Your Point de Livraison number for meter access",
      },
      "step-3": {
        title: "Start receiving solar",
        description: "Begin saving immediately with local solar energy",
      },
    },
  },
  "keep-your-supplier": {
    title: "Keep your electricity supplier",
    body: "Community solar supplements your current electricity supplier — it does not replace it. You'll continue to receive your regular electricity bill from your supplier (EDF, Engie, etc.), but the energy consumed from your solar community will be at a reduced rate. Your supplier still handles the grid connection, customer service, and all regulated charges (TURPE, taxes). Community solar simply provides you with cheaper, local renewable energy.",
    "bill-title": "Your Electricity Bill",
    "bill-items": {
      "community-solar": {
        label: "Community Solar",
        description: "Local renewable energy at reduced rate",
      },
      "supplier-portion": {
        label: "Supplier portion",
        description: "Grid fees (TURPE), taxes, and services",
      },
    },
    "bill-footnote": "One bill, two sources — seamless integration",
  },
  "track-your-impact": {
    title: "Track your impact",
    subtitle:
      "Access your personalized dashboard to monitor savings and environmental impact",
    "image-alt": "Track your impact dashboard",
  },
  "already-have-panels": {
    title: "Already have solar panels?",
    subtitle:
      "Earn more by selling locally. Join our producer network and maximize your solar investment.",
    cta: "Become a producer",
  },
  cta: {
    title: "Join a solar community near you",
    subtitle:
      "Start saving on your electricity bill while supporting local renewable energy.",
    button: "Find a community near me",
  },
}
